import httpRequestMethodEnum from './enums/httpRequestMethod';
import { apiEndpointEnum } from './enums/apiEndpoints';
import { baseURLEnum } from './enums/baseURL';
import { getBaselineJWT } from './libJWT';
import { getSessionToken } from './auth';
import { baseURL } from '../baselineApis';

export const columbiaAPI = {
  user: {
    getOrganizations: async () => {
      return getSessionToken().then((token)=> {
        const url = `${baseURL(baseURLEnum.COLUMBIA)}/user/organizations`;

        const request = new Request(url, {
          method: "GET",
          headers : {
            Application: 'Baseline',
            Authorization: token,
            accept: '*/*',
            organization: 0,
          }
        });

        return fetch(request).then((response) => { 
          return response.json(); 
        });

      });
    }
  }
}